interface IconPinProps extends React.SVGProps<SVGSVGElement> {}

const IconPin = (props: IconPinProps) => {
  return (
    <svg viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 8.19239L5.52898 8.20308L5.52467 13.2318C5.52422 13.6533 5.28576 13.9997 4.99432 14C4.70377 14.0006 4.46506 13.6564 4.46583 13.234L4.47077 8.20512L0 8.21508C0.181529 6.96891 0.962214 5.88632 2.07973 5.18822L2.08309 1.60209L1.25693 1.60409L1.25845 0.0163065L8.75648 0L8.75467 1.58726L7.92851 1.58926L7.92515 5.17539C9.04229 5.86786 9.82076 6.94754 10 8.19239ZM3.14228 1.44481V4.64694H4.05835V1.44481H3.14228Z"
        fill={"#E6A300"}
      />
    </svg>
  );
};

export { IconPin };
